











import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";

import { IPortalUser } from "../../models/interfaces/authentication/portal-user.model.interface";

import UserTable from "@/components/user/tables/UserTable.vue";
import PublisherAccess from "@/components/user/tables/PublisherAccess.vue";

const UserManagementModule = namespace("userManagementModule");

@Component({
    components: {
        UserTable,
        PublisherAccess
    }
})
export default class User extends Vue {
    @UserManagementModule.Action public setUser;
    @UserManagementModule.Getter public user;

    @Prop() public id: number;

    @Provide() public userModel: IPortalUser | null = null;

    public created() {
        this.setUser(this.id).then((result) => {
            this.userModel = this.user;
        });
    }
}
